import {Pipe, PipeTransform} from "@angular/core";


@Pipe({name: 'HTMLEntitiesCleaner', standalone: false})
export class HtmlEntitiesCleanerPipe implements PipeTransform {
    transform(text: string) {
        return new DOMParser().parseFromString(text, "text/html").documentElement.textContent;
    }
}